module.exports = __webpack_public_path__ + "img/logo.9d59d10b.png";